import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, NgModule } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import * as i7 from '@angular/forms';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule, FormsModule } from '@angular/forms';
import * as i3 from '@angular/material/tree';
import { MatTreeNestedDataSource, MatTreeModule } from '@angular/material/tree';
import { of } from 'rxjs';
import * as i1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i2 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i4 from '@angular/material/core';
import * as i5 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i6 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

class MatTreeSelectInputService {
    constructor() { }
}
MatTreeSelectInputService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
MatTreeSelectInputService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class MatTreeSelectInputComponent {
    constructor() {
        this.controlName = {};
        this.options = [];
        this.placeholder = '';
        this.multiple = false;
        this.heading = "";
        this.canSelectParentNode = true;
        this._getChildren = (node) => of(node.children);
        this.hasNestedChild = (_, nodeData) => {
            var _a;
            return (((_a = nodeData.children) === null || _a === void 0 ? void 0 : _a.length) > 0);
        };
        this.nestedTreeControl = new NestedTreeControl(this._getChildren);
        this.nestedDataSource = new MatTreeNestedDataSource();
    }
    ngOnInit() {
        this.nestedDataSource.data = this.options;
    }
    ngOnChanges(changes) {
        var _a, _b;
        if (((_a = changes.options) === null || _a === void 0 ? void 0 : _a.currentValue) !== ((_b = changes.options) === null || _b === void 0 ? void 0 : _b.previousValue)) {
            this.nestedDataSource.data = this.options;
        }
    }
}
MatTreeSelectInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MatTreeSelectInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: MatTreeSelectInputComponent, selector: "ngx-mat-tree-select-input", inputs: { controlName: "controlName", options: "options", placeholder: "placeholder", multiple: "multiple", heading: "heading", canSelectParentNode: "canSelectParentNode" }, usesOnChanges: true, ngImport: i0, template: `
   
   <mat-form-field appearance="outline">
        <mat-select [id]="controlName"  [placeholder]="placeholder" [multiple] = "multiple" [formControlName]="controlName">
            <ng-content></ng-content>

            <mat-tree class="example-tree mat-tree-position" [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node  class="mat-tree-node"  *matTreeNodeDef="let node" >
                  <mat-option [title] = "node.name" [value]="node">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <p style="margin-left: 35px;" class="tree_text">  {{node.name}} </p>
                  </mat-option>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <!-- <mat-option> -->
                  <mat-nested-tree-node    *matTreeNodeDef="let node; when: hasNestedChild" >
                      <div style="display: flex" >
                      <button  class="tree-toggle" mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'toggle ' + node.name" >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              <mat-option [title] = "node.name"  [disabled] = "!canSelectParentNode" style="display: flex;" class="mat-tree-node" [value]="node">

                      {{node.name}}
                    </mat-option>

                    </div>

                    <ul [class.example-tree-invisible]="!nestedTreeControl.isExpanded(node)">
                      <p *ngIf="heading !== ''" class="title"> {{heading + " " + node.name}}</p>

                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
          
                  </mat-nested-tree-node>
                <!-- </mat-option> -->
              </mat-tree>

        </mat-select>


    </mat-form-field>

    
  `, isInline: true, styles: [".example-tree-invisible {\n    display: none;\n}\n.example-tree ul, .example-tree li {\n    margin-top: 0;\n    margin-bottom: 0;\n    list-style-type: none;\n}\n.mat-tree {\n    width: 100%;\n    margin-top: 15px;\n    box-sizing: border-box;\n}\n.mat-tree button {\n    height: 33px;\n    width: 33px;\n    line-height: 33px;\n    color: #777;\n    margin-left: 0px;\n    margin-right: 0px;\n}\n.mattreenodetoggle {\n    color: #777;\n}\n.mat-tree-node {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    min-height: 0;\n    position: relative;\n}\n:host ::ng-deep .mat-option-text {\n    display: flex !important;\n    align-items: center;\n    font-size: 12px;\n    min-height: 0;\n    position: relative;\n}\n.actions {\n    display: flex;\n    align-items: center;\n    margin-left: 30px;\n}\n.tree-toggle {\n    position: relative;\n}\n.title {\n    margin-right: auto;\n    margin-bottom: 0;\n    font-weight: 500;\n    color: #777;\n    align-self: flex-end;\n    font-size: 12px;\n    margin-left: 20px;\n    padding-top: 10px;\n}\n.tree_text {\n    margin-bottom: 0;\n    width: 100px;\n    line-height: normal;\n}\nul {\n    padding: 0px;\n    margin-bottom: 10px !important;\n    margin-left: 51px;\n}\nmat-tree-node {\n    position: relative;\n}\nmat-tree-node::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    height: 1px;\n    width: 40px;\n}\n"], components: [{ type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i2.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i3.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i7.FormControlName, selector: "[formControlName]", inputs: ["disabled", "formControlName", "ngModel"], outputs: ["ngModelChange"] }, { type: i3.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { type: i3.MatTreeNode, selector: "mat-tree-node", inputs: ["role", "disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { type: i3.MatNestedTreeNode, selector: "mat-nested-tree-node", inputs: ["role", "disabled", "tabIndex", "matNestedTreeNode"], exportAs: ["matNestedTreeNode"] }, { type: i3.MatTreeNodeToggle, selector: "[matTreeNodeToggle]", inputs: ["matTreeNodeToggleRecursive"] }, { type: i8.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.MatTreeNodeOutlet, selector: "[matTreeNodeOutlet]" }], viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ngx-mat-tree-select-input',
                    template: `
   
   <mat-form-field appearance="outline">
        <mat-select [id]="controlName"  [placeholder]="placeholder" [multiple] = "multiple" [formControlName]="controlName">
            <ng-content></ng-content>

            <mat-tree class="example-tree mat-tree-position" [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node  class="mat-tree-node"  *matTreeNodeDef="let node" >
                  <mat-option [title] = "node.name" [value]="node">
                    <!-- use a disabled button to provide padding for tree leaf -->
                    <p style="margin-left: 35px;" class="tree_text">  {{node.name}} </p>
                  </mat-option>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <!-- <mat-option> -->
                  <mat-nested-tree-node    *matTreeNodeDef="let node; when: hasNestedChild" >
                      <div style="display: flex" >
                      <button  class="tree-toggle" mat-icon-button matTreeNodeToggle
                      [attr.aria-label]="'toggle ' + node.name" >
                <mat-icon class="mat-icon-rtl-mirror">
                  {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              <mat-option [title] = "node.name"  [disabled] = "!canSelectParentNode" style="display: flex;" class="mat-tree-node" [value]="node">

                      {{node.name}}
                    </mat-option>

                    </div>

                    <ul [class.example-tree-invisible]="!nestedTreeControl.isExpanded(node)">
                      <p *ngIf="heading !== ''" class="title"> {{heading + " " + node.name}}</p>

                      <ng-container matTreeNodeOutlet></ng-container>
                    </ul>
          
                  </mat-nested-tree-node>
                <!-- </mat-option> -->
              </mat-tree>

        </mat-select>


    </mat-form-field>

    
  `,
                    styles: [`.example-tree-invisible {
    display: none;
}
.example-tree ul, .example-tree li {
    margin-top: 0;
    margin-bottom: 0;
    list-style-type: none;
}
.mat-tree {
    width: 100%;
    margin-top: 15px;
    box-sizing: border-box;
}
.mat-tree button {
    height: 33px;
    width: 33px;
    line-height: 33px;
    color: #777;
    margin-left: 0px;
    margin-right: 0px;
}
.mattreenodetoggle {
    color: #777;
}
.mat-tree-node {
    display: flex;
    align-items: center;
    font-size: 12px;
    min-height: 0;
    position: relative;
}
:host ::ng-deep .mat-option-text {
    display: flex !important;
    align-items: center;
    font-size: 12px;
    min-height: 0;
    position: relative;
}
.actions {
    display: flex;
    align-items: center;
    margin-left: 30px;
}
.tree-toggle {
    position: relative;
}
.title {
    margin-right: auto;
    margin-bottom: 0;
    font-weight: 500;
    color: #777;
    align-self: flex-end;
    font-size: 12px;
    margin-left: 20px;
    padding-top: 10px;
}
.tree_text {
    margin-bottom: 0;
    width: 100px;
    line-height: normal;
}
ul {
    padding: 0px;
    margin-bottom: 10px !important;
    margin-left: 51px;
}
mat-tree-node {
    position: relative;
}
mat-tree-node::after {
    content: '';
    position: absolute;
    left: 0;
    height: 1px;
    width: 40px;
}
`],
                    viewProviders: [
                        {
                            provide: ControlContainer,
                            useExisting: FormGroupDirective
                        }
                    ]
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { controlName: [{
                type: Input
            }], options: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], multiple: [{
                type: Input
            }], heading: [{
                type: Input
            }], canSelectParentNode: [{
                type: Input
            }] } });

class MatTreeSelectInputNgmodelComponent {
    constructor() {
        this.select = "";
        this.selectChange = new EventEmitter();
        this.selectionChanged = new EventEmitter();
        this.options = [];
        this.placeholder = '';
        this.multiple = false;
        this.heading = "";
        this.canSelectParentNode = true;
        this._getChildren = (node) => of(node.children);
        this.hasNestedChild = (_, nodeData) => {
            var _a;
            return (((_a = nodeData.children) === null || _a === void 0 ? void 0 : _a.length) > 0);
        };
        this.nestedTreeControl = new NestedTreeControl(this._getChildren);
        this.nestedDataSource = new MatTreeNestedDataSource();
    }
    ngOnInit() {
        this.nestedDataSource.data = this.options;
    }
    ngOnChanges(changes) {
        var _a, _b;
        if (((_a = changes.options) === null || _a === void 0 ? void 0 : _a.currentValue) !== ((_b = changes.options) === null || _b === void 0 ? void 0 : _b.previousValue)) {
            this.nestedDataSource.data = this.options;
        }
    }
}
MatTreeSelectInputNgmodelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputNgmodelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MatTreeSelectInputNgmodelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.1.5", type: MatTreeSelectInputNgmodelComponent, selector: "ngx-mat-tree-select-input-ngmodel", inputs: { select: "select", options: "options", placeholder: "placeholder", multiple: "multiple", heading: "heading", canSelectParentNode: "canSelectParentNode" }, outputs: { selectChange: "selectChange", selectionChanged: "selectionChanged" }, usesOnChanges: true, ngImport: i0, template: "<mat-form-field appearance=\"outline\">\n  <mat-select [placeholder]=\"placeholder\" [multiple]=\"multiple\" (selectionChange)='selectionChanged.emit(select)'\n    [(ngModel)]=\"select\" (ngModelChange)=\"selectChange.emit(select)\">\n    <ng-content></ng-content>\n\n    <mat-tree class=\"example-tree mat-tree-position\" [dataSource]=\"nestedDataSource\" [treeControl]=\"nestedTreeControl\">\n      <!-- This is the tree node template for leaf nodes -->\n      <mat-tree-node class=\"mat-tree-node\" *matTreeNodeDef=\"let node\">\n        <mat-option [title] = \"node.name\" [value]=\"node\">\n          <!-- use a disabled button to provide padding for tree leaf -->\n          <p style=\"margin-left: 35px;\" class=\"tree_text\"> {{node.name}} </p>\n        </mat-option>\n      </mat-tree-node>\n      <!-- This is the tree node template for expandable nodes -->\n      <!-- <mat-option> -->\n      <mat-nested-tree-node *matTreeNodeDef=\"let node; when: hasNestedChild\">\n        <div style=\"display: flex\">\n          <button class=\"tree-toggle\" mat-icon-button matTreeNodeToggle [attr.aria-label]=\"'toggle ' + node.name\">\n            <mat-icon class=\"mat-icon-rtl-mirror\">\n              {{nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}\n            </mat-icon>\n          </button>\n          <mat-option [title] = \"node.name\"  [disabled] = \"!canSelectParentNode\" style=\"display: flex;\" class=\"mat-tree-node\" [value]=\"node\">\n\n            {{node.name}}\n          </mat-option>\n\n        </div>\n\n        <ul [class.example-tree-invisible]=\"!nestedTreeControl.isExpanded(node)\">\n          <p *ngIf=\"heading !== ''\" class=\"title\"> {{heading + \" \" + node.name}}</p>\n          <ng-container matTreeNodeOutlet></ng-container>\n        </ul>\n\n      </mat-nested-tree-node>\n      <!-- </mat-option> -->\n    </mat-tree>\n\n  </mat-select>\n\n\n</mat-form-field>", styles: [".example-tree-invisible{display:none}.example-tree ul,.example-tree li{margin-top:0;margin-bottom:0;list-style-type:none}.mat-tree{width:100%;margin-top:15px;box-sizing:border-box}.mat-tree button{height:33px;width:33px;line-height:33px;color:#777;margin-left:0;margin-right:0}.mattreenodetoggle{color:#777}.mat-tree-node{display:flex;align-items:center;font-size:12px;min-height:0;position:relative}:host ::ng-deep .mat-option-text{display:flex!important;align-items:center;font-size:12px;min-height:0;position:relative}.actions{display:flex;align-items:center;margin-left:30px}.tree-toggle{position:relative}.title{margin-right:auto;margin-bottom:0;font-weight:500;color:#777;align-self:flex-end;font-size:12px;margin-left:20px;padding-top:10px}.tree_text{margin-bottom:0;width:100px;line-height:normal}ul{padding:0;margin-bottom:10px!important;margin-left:51px}mat-tree-node{position:relative}mat-tree-node:after{content:\"\";position:absolute;left:0;height:1px;width:40px}\n"], components: [{ type: i1.MatFormField, selector: "mat-form-field", inputs: ["color", "floatLabel", "appearance", "hideRequiredMarker", "hintLabel"], exportAs: ["matFormField"] }, { type: i2.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { type: i3.MatTree, selector: "mat-tree", exportAs: ["matTree"] }, { type: i4.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { type: i5.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i6.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i7.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i7.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i3.MatTreeNodeDef, selector: "[matTreeNodeDef]", inputs: ["matTreeNodeDefWhen", "matTreeNode"] }, { type: i3.MatTreeNode, selector: "mat-tree-node", inputs: ["role", "disabled", "tabIndex"], exportAs: ["matTreeNode"] }, { type: i3.MatNestedTreeNode, selector: "mat-nested-tree-node", inputs: ["role", "disabled", "tabIndex", "matNestedTreeNode"], exportAs: ["matNestedTreeNode"] }, { type: i3.MatTreeNodeToggle, selector: "[matTreeNodeToggle]", inputs: ["matTreeNodeToggleRecursive"] }, { type: i8.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.MatTreeNodeOutlet, selector: "[matTreeNodeOutlet]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputNgmodelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ngx-mat-tree-select-input-ngmodel',
                    templateUrl: './mat-tree-select-input-ngmodel.component.html',
                    styleUrls: ['./mat-tree-select-input-ngmodel.component.css']
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { select: [{
                type: Input
            }], selectChange: [{
                type: Output
            }], selectionChanged: [{
                type: Output
            }], options: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], multiple: [{
                type: Input
            }], heading: [{
                type: Input
            }], canSelectParentNode: [{
                type: Input
            }] } });

class MatTreeSelectInputModule {
}
MatTreeSelectInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MatTreeSelectInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputModule, declarations: [MatTreeSelectInputComponent,
        MatTreeSelectInputNgmodelComponent], imports: [MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTreeModule,
        MatIconModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatButtonModule], exports: [MatTreeSelectInputComponent,
        MatTreeSelectInputNgmodelComponent] });
MatTreeSelectInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputModule, imports: [[
            MatInputModule,
            MatFormFieldModule,
            MatSelectModule,
            MatTreeModule,
            MatIconModule,
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            MatButtonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.1.5", ngImport: i0, type: MatTreeSelectInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MatTreeSelectInputComponent,
                        MatTreeSelectInputNgmodelComponent
                    ],
                    imports: [
                        MatInputModule,
                        MatFormFieldModule,
                        MatSelectModule,
                        MatTreeModule,
                        MatIconModule,
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        MatButtonModule
                    ],
                    exports: [
                        MatTreeSelectInputComponent,
                        MatTreeSelectInputNgmodelComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of mat-tree-select-input
 */

/**
 * Generated bundle index. Do not edit.
 */

export { MatTreeSelectInputComponent, MatTreeSelectInputModule, MatTreeSelectInputNgmodelComponent, MatTreeSelectInputService };
